<mat-list>
  <app-lecture-member-item *ngFor="let user of (usersObservable | async)" [user]="user" [lecture]="lecture"></app-lecture-member-item>
</mat-list>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-member-list/lecture-member-list.component.html